import { Box } from '@gemini/core';
import { Checkbox } from '@gemini/ui';
import { IFieldProps } from '@mfe-types/field';
import { CSSObject, Global } from '@emotion/react';

const checkboxStyles = (className: string, fontSize: string): CSSObject => ({
    [`.${className}`]: {
        label: {
            fontSize,
        },
    },
});

const CheckboxWrapper = ({ field, texts, styles }: Required<IFieldProps<any, any>>) => {
    return (
        <Box testId={field.name} unsafe_className={field.name}>
            {styles?.fontSize && <Global styles={checkboxStyles(field.name, styles.fontSize)} />}
            <Checkbox
                {...field}
                aria-describedby={texts.additionalText ? `${field.name}-description` : undefined}
                key={field.name}
                defaultSelected={field.value === true}
            >
                {texts.label || ''}
            </Checkbox>
            {texts.additionalText ? (
                <Box
                    as="p"
                    typography="typography.body.14.regular"
                    testId="additional-text"
                    marginVertical="spacing.none"
                    color="color.content.light.default"
                    marginLeft="spacing.32"
                    paddingLeft="spacing.8"
                    id={`${field.name}-description`}
                >
                    {texts.additionalText}
                </Box>
            ) : null}
        </Box>
    );
};

export default CheckboxWrapper;
